import { ICommonSettings, ILanguageModel, INotificationPermissionLabelSetting } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigNotificationPermissionLabelsSettings } from "./app-settings-config-notification-permission-labels";

export interface IConfigNotificationPermissionInputState {
  showNotificationPermissionLabelsModal: boolean;
  editingNotificationPermissionLabelsId: string;
}

export interface IConfigNotificationPermissionInputProps {
  parentData: string;
  languages: ILanguageModel[];
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigNotificationPermissionInput extends PureComponent<
  IConfigNotificationPermissionInputProps,
  IConfigNotificationPermissionInputState
> {
  formInputName = ["", "notificationPermissionLabelSettingsId"];

  constructor(props: IConfigNotificationPermissionInputProps) {
    super(props);
    this.formInputName[0] = props.parentData;
    this.state = {
      showNotificationPermissionLabelsModal: false,
      editingNotificationPermissionLabelsId: ""
    };
  }

  openNotificationPermissionLabelsModal = () => {
    this.setState({
      editingNotificationPermissionLabelsId: "",
      showNotificationPermissionLabelsModal: true
    });
  };

  closeNotificationPermissionLabelsModal = () => {
    this.setState({ showNotificationPermissionLabelsModal: false });
  };

  setEditingNotificationPermissionLabels = (id: string) => {
    this.setState({
      editingNotificationPermissionLabelsId: id,
      showNotificationPermissionLabelsModal: true
    });
  };

  render() {
    const options = [
      {
        id: null,
        name: "Default"
      } as unknown as INotificationPermissionLabelSetting,
      ...(this.props.commonSettings.notificationPermissionLabelSettings || [])
    ];
    return (
      <>
        <ConfigNotificationPermissionLabelsSettings
          formInputName={this.formInputName}
          closeModal={this.closeNotificationPermissionLabelsModal}
          showModal={this.state.showNotificationPermissionLabelsModal}
          editingNotificationPermissionLabelsId={this.state.editingNotificationPermissionLabelsId}
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Permission text"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey={
            this.props.parentData === "androidConfig"
              ? "android_pushnotification_permissiontext"
              : "ios_pushnotification_permissiontext"
          }
          onAddNew={this.openNotificationPermissionLabelsModal}
          onEdit={this.setEditingNotificationPermissionLabels}
          dropdownTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_pushnotification_permissiontext"
              : "ios_pushnotification_permissiontext"
          }Dropdown`}
          addNewTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_pushnotification_permissiontext"
              : "ios_pushnotification_permissiontext"
          }AddNewButton`}
          editTestId={`${
            this.props.parentData === "androidConfig"
              ? "android_pushnotification_permissiontext"
              : "ios_pushnotification_permissiontext"
          }EditButton`}
        />
      </>
    );
  }
}
